import { useCallback } from 'react';
import { useHandleApiResponse, useToast } from '../../../hooks';
import { useCreateFolderMutation } from '../../../services';
import { AlertType, TextButton } from '../../shared';

interface CreateFolderButtonProps {
  nameInput: string;
  selectedFolderId: string | null;
  closeModal: () => void;
}

const CreateFolderButton = ({ nameInput, selectedFolderId, closeModal }: CreateFolderButtonProps) => {
  const [createFolder, { isLoading: isCreatingFolder }] = useCreateFolderMutation();

  const handleApiResponse = useHandleApiResponse();
  const { showToast } = useToast();

  const onCreate = useCallback(async () => {
    try {
      const response = await createFolder({ name: nameInput, parentId: selectedFolderId });
      handleApiResponse({ response, onSuccess: closeModal });
    } catch (error) {
      console.error(error);
      showToast({
        message: 'An unexpected error occurred while creating the folder. Please try again.',
        type: AlertType.ERROR,
      });
    }
  }, [nameInput, selectedFolderId, closeModal, createFolder, handleApiResponse, showToast]);

  return <TextButton disabled={!nameInput} loading={isCreatingFolder} text="Create" onClick={onCreate} />;
};

export default CreateFolderButton;
